const IconLocationPin = ({ className }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M10 18s6-5.686 6-10.5A6 6 0 1 0 4 7.5C4 12.314 10 18 10 18Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
      <circle cx="10" cy="7.5" r="2" stroke="currentColor" strokeWidth="1.4" />
    </svg>
  );
};

export default IconLocationPin;
